module.exports = __webpack_public_path__ + "./images/placeCard.28fe45ea3a6311d20ee45394d8cd962b.png";